// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Conteneur principal */
.note-editor-container {
  font-family: "Arial", sans-serif;
  background-color: #f3e8a99d;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  position: relative; /* Change from absolute to relative */
  width: 25%; /* Prendre environ 1/4 de la largeur */
  overflow: auto;
  margin-left: auto; /* Align to the right */
}

/* Titre du Bloc-Note */
.editor-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: center;
  color: #333;
}

/* Style de l'éditeur Quill */
.note-editor {
  flex-grow: 1;
  padding: 15px;
  font-size: 1rem;
  line-height: 1.5;
  background-color: #fff;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  box-sizing: border-box;
}

/* Style de la barre d'outils */
.ql-toolbar {
  background-color: #fafafa;
  border: 1px solid #e1e1e1;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* Boutons de la barre d'outils */
.ql-toolbar button {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 8px 12px;
  margin: 5px;
  cursor: pointer;
  border-radius: 6px;
  font-size: 16px;
  transition: all 0.2s ease;
}

/* Effet au survol des boutons de la barre d'outils */
.ql-toolbar button:hover {
  background-color: #e9e9e9;
  border-color: #bbb;
  color: #333;
}

/* Tooltip (info-bulle) qui apparaît au survol des icônes */
.ql-toolbar button:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.ql-toolbar button:hover::after {
  opacity: 1;
}

/* Éditeur Quill - Textes riches */
.ql-editor p {
  margin: 10px 0;
  font-size: 1rem;
}

/* Ajout d'un fond subtil lorsque l'éditeur est actif */
.note-editor:focus {
  outline: none;
  background-color: #fafafa;
}
`, "",{"version":3,"sources":["webpack://./src/Components/NoteEditor/NoteEditor.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB,EAAE,qCAAqC;EACzD,UAAU,EAAE,sCAAsC;EAClD,cAAc;EACd,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA,2DAA2D;AAC3D;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":["/* Conteneur principal */\n.note-editor-container {\n  font-family: \"Arial\", sans-serif;\n  background-color: #f3e8a99d;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n  position: relative; /* Change from absolute to relative */\n  width: 25%; /* Prendre environ 1/4 de la largeur */\n  overflow: auto;\n  margin-left: auto; /* Align to the right */\n}\n\n/* Titre du Bloc-Note */\n.editor-title {\n  font-size: 2rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n  text-align: center;\n  color: #333;\n}\n\n/* Style de l'éditeur Quill */\n.note-editor {\n  flex-grow: 1;\n  padding: 15px;\n  font-size: 1rem;\n  line-height: 1.5;\n  background-color: #fff;\n  border: 1px solid #e1e1e1;\n  border-radius: 6px;\n  box-sizing: border-box;\n}\n\n/* Style de la barre d'outils */\n.ql-toolbar {\n  background-color: #fafafa;\n  border: 1px solid #e1e1e1;\n  padding: 10px;\n  border-radius: 6px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Boutons de la barre d'outils */\n.ql-toolbar button {\n  background-color: transparent;\n  border: 1px solid #ccc;\n  padding: 8px 12px;\n  margin: 5px;\n  cursor: pointer;\n  border-radius: 6px;\n  font-size: 16px;\n  transition: all 0.2s ease;\n}\n\n/* Effet au survol des boutons de la barre d'outils */\n.ql-toolbar button:hover {\n  background-color: #e9e9e9;\n  border-color: #bbb;\n  color: #333;\n}\n\n/* Tooltip (info-bulle) qui apparaît au survol des icônes */\n.ql-toolbar button:hover::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  background-color: #333;\n  color: #fff;\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 4px;\n  bottom: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.ql-toolbar button:hover::after {\n  opacity: 1;\n}\n\n/* Éditeur Quill - Textes riches */\n.ql-editor p {\n  margin: 10px 0;\n  font-size: 1rem;\n}\n\n/* Ajout d'un fond subtil lorsque l'éditeur est actif */\n.note-editor:focus {\n  outline: none;\n  background-color: #fafafa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
